/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFriendsListResponse } from './IFriendsListResponse';
import {
    IFriendsListResponseFromJSON,
    IFriendsListResponseFromJSONTyped,
    IFriendsListResponseToJSON,
    IFriendsListResponseToJSONTyped,
} from './IFriendsListResponse';

/**
 * 
 * @export
 * @interface GetMyFriendsResponse
 */
export interface GetMyFriendsResponse {
    /**
     * 
     * @type {IFriendsListResponse}
     * @memberof GetMyFriendsResponse
     */
    friendsList: IFriendsListResponse;
}

/**
 * Check if a given object implements the GetMyFriendsResponse interface.
 */
export function instanceOfGetMyFriendsResponse(value: object): value is GetMyFriendsResponse {
    if (!('friendsList' in value) || value['friendsList'] === undefined) return false;
    return true;
}

export function GetMyFriendsResponseFromJSON(json: any): GetMyFriendsResponse {
    return GetMyFriendsResponseFromJSONTyped(json, false);
}

export function GetMyFriendsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMyFriendsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'friendsList': IFriendsListResponseFromJSON(json['friendsList']),
    };
}

export function GetMyFriendsResponseToJSON(json: any): GetMyFriendsResponse {
    return GetMyFriendsResponseToJSONTyped(json, false);
}

export function GetMyFriendsResponseToJSONTyped(value?: GetMyFriendsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'friendsList': IFriendsListResponseToJSON(value['friendsList']),
    };
}

